
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-3 -6 24 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 6V-6H-3V6z","fill":"#dc241f"}}),_c('path',{attrs:{"d":"M-3-6V6L9 0z","fill":"#ffc726"}}),_c('path',{attrs:{"d":"M-3-6V6l8-6z"}}),_c('g',{attrs:{"transform":"rotate(-26.565)"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0-2.1V0h1z","fill":"#fff","transform":"rotate(18 0 -2.1)","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144)"}})])])
          )
        }
      }
    